// extracted by mini-css-extract-plugin
export default {"ace-c-commissioning-contract-partner-panel__phone-link":"commissioning-contract-partner-panel__phone-link---8500027d"};